import { Component, ElementRef, Renderer2 } from '@angular/core';
import { PrintCardContentComponent } from '../../shared/print-card-content.component';
import { PopsCannabis5By5CardStackContentViewModel } from './pops-cannabis-5-by-5-card-stack-content-view-model';

@Component({
  selector: 'app-pops-cannabis5by5-card-stack-content',
  templateUrl: './pops-cannabis-5-by-5-card-stack-content.component.html',
  styleUrls: ['./pops-cannabis-5-by-5-card-stack-content.component.scss'],
  providers: [PopsCannabis5By5CardStackContentViewModel],
  standalone: false
})
export class PopsCannabis5By5CardStackContentComponent extends PrintCardContentComponent {
  constructor(
    public override viewModel: PopsCannabis5By5CardStackContentViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }
}
